import { useTranslation } from 'react-i18next';
import kioskLanguageService from 'services/kiosk-language-service';
import { KIOSK__LANGUAGE_SELECTOR } from 'translations/constants';
import { KIOSK_LANGUAGES, toKioskLang } from 'utils/kiosk-language';
import { KioskLanguageGroup, KioskLanguageOption } from '../styles';

/**
 * Always-visible kiosk language switch. Lives in the persistent header, so it is the same control on
 * the selection screen and in every sub-flow (PIN, clock-in, clock-out) and switching never resets the
 * current step. Needs no authentication and changes only the display language.
 */
const KioskLanguageSelector = () => {
  // Read off the live instance: resume applies the session language after this mounts.
  const [t, i18n] = useTranslation();
  const active = toKioskLang(i18n.language);

  return (
    <KioskLanguageGroup
      role="radiogroup"
      aria-label={t(KIOSK__LANGUAGE_SELECTOR)}
      id="kiosk-language-selector"
      data-testid="kiosk-language-selector"
    >
      {KIOSK_LANGUAGES.map(lang => {
        const isActive = active === lang;
        return (
          <KioskLanguageOption
            key={lang}
            role="radio"
            aria-checked={isActive}
            active={isActive}
            onClick={() => {
              if (!isActive) kioskLanguageService.select(lang);
            }}
            id={`kiosk-language-option-${lang}`}
            data-testid={`kiosk-language-option-${lang}`}
          >
            {lang.toUpperCase()}
          </KioskLanguageOption>
        );
      })}
    </KioskLanguageGroup>
  );
};

export default KioskLanguageSelector;
